// html.JS
jQuery(function($) {

	window.lenis = null;
	window.isMobile = null;
	window.isTablet = null;
	window.isPhone = null;
	window.isTouchDevice = null;
	window.isPointerDevice = null;
	window.isEn = window.location.href.includes("en");

	/**
	 *    ########   #######   ######     ########  ########    ###    ########  ##    ## 
	 *    ##     ## ##     ## ##    ##    ##     ## ##         ## ##   ##     ##  ##  ##  
	 *    ##     ## ##     ## ##          ##     ## ##        ##   ##  ##     ##   ####   
	 *    ##     ## ##     ## ##          ########  ######   ##     ## ##     ##    ##    
	 *    ##     ## ##     ## ##          ##   ##   ##       ######### ##     ##    ##    
	 *    ##     ## ##     ## ##    ##    ##    ##  ##       ##     ## ##     ##    ##    
	 *    ########   #######   ######     ##     ## ######## ##     ## ########     ##    
    */

	$(document).ready(function() {

		/**
		 *     ######  ##       #### ########  ########  ######  ##     ##  #######  ##      ## 
		 *    ##    ## ##        ##  ##     ## ##       ##    ## ##     ## ##     ## ##  ##  ## 
		 *    ##       ##        ##  ##     ## ##       ##       ##     ## ##     ## ##  ##  ## 
		 *     ######  ##        ##  ##     ## ######    ######  ######### ##     ## ##  ##  ## 
		 *          ## ##        ##  ##     ## ##             ## ##     ## ##     ## ##  ##  ## 
		 *    ##    ## ##        ##  ##     ## ##       ##    ## ##     ## ##     ## ##  ##  ## 
		 *     ######  ######## #### ########  ########  ######  ##     ##  #######   ###  ###  
		 */
		const slideshows = document.querySelectorAll('.slideshow');

		slideshows.forEach(slideshow => {

			const initSlideshow = () => {

				const slides = slideshow.querySelectorAll('.slide');

				if (!slides.length) return;
				

				if (!slideshow.querySelector('.slide.active')) {
					console.warn('Aucun slide actif trouvé, activation du premier slide', slideshow);
					slides[0].classList.add('active');
				}

				return setInterval(() => {

					const slides = slideshow.querySelectorAll('.slide');
					const active = slideshow.querySelector('.slide.active');

					if (!active) {
						console.error('Aucun .slide.active trouvé pendant la transition', slideshow);
						return;
					}

					let next = active.nextElementSibling;

					// Vérifie que le sibling existe ET qu'il possède la classe .slide
					if (!next || !next.classList.contains('slide')) {
						next = slides[0];
					}

					// Sécurité anti-null
					if (!next) {
						console.error('Impossible de trouver le prochain slide', slideshow);
						return;
					}

					active.classList.remove('active');
					active.classList.add('transiting');

					next.classList.add('active');

					setTimeout(() => {
						active.classList.remove('transiting');
					}, 2500);

				}, 3000);
			};

			initSlideshow();
		});


		/**
		 *                                        
		 *     #####   ####  #####  #    # #####  
		 *     #    # #    # #    # #    # #    # 
		 *     #    # #    # #    # #    # #    # 
		 *     #####  #    # #####  #    # #####  
		 *     #      #    # #      #    # #      
		 *     #       ####  #       ####  #      
		 *                                        
		 */
		if ($('.md-modal').length !== 0) {

			const handlePopupState = () => {
				const modalIsOpen = $('html, body').hasClass('modal-open');

				if (modalIsOpen) {
					$('html, body').removeClass('modal-open');
					$('#modal-1').removeClass("md-show");
				}
				else {
					$('html, body').addClass('modal-open');
					$('#modal-1').addClass("md-show");
				}
			}
			
			// After 3 seconds, open the popup
			setTimeout(() => {
				handlePopupState();
				lenis.stop();
				refreshLenis();
			}, 5000);

					
			// Close popup when clicking the overlay
			$(".md-overlay").click(function(e) {
				if (e.target === this) {
					handlePopupState();
					lenis.start();
					refreshLenis();
				}
			});

			// Close popup when clicking the close button
			$('.mfp-close').on('click', function(e) {
				e.preventDefault();
				e.stopPropagation();
				handlePopupState();
				lenis.start();
				refreshLenis();
			});

			// Close popup with Escape key
			$(document).keydown(function(e) {
				if (e.keyCode === 27) {
					handlePopupState();
					lenis.start();
					refreshLenis();
				}
			});

			// Prevent popup content clicks from closing the popup
			$('.popup-content').click(function(e) {
				e.stopPropagation();
			});
		}

	});

	/**
	 *    ########  ##    ## ##    ##    ###    ##     ## ####  ######     ##     ## #### ######## ##      ##    ##     ## ######## ####  ######   ##     ## ######## 
	 *    ##     ##  ##  ##  ###   ##   ## ##   ###   ###  ##  ##    ##    ##     ##  ##  ##       ##  ##  ##    ##     ## ##        ##  ##    ##  ##     ##    ##    
	 *    ##     ##   ####   ####  ##  ##   ##  #### ####  ##  ##          ##     ##  ##  ##       ##  ##  ##    ##     ## ##        ##  ##        ##     ##    ##    
	 *    ##     ##    ##    ## ## ## ##     ## ## ### ##  ##  ##          ##     ##  ##  ######   ##  ##  ##    ######### ######    ##  ##   #### #########    ##    
	 *    ##     ##    ##    ##  #### ######### ##     ##  ##  ##           ##   ##   ##  ##       ##  ##  ##    ##     ## ##        ##  ##    ##  ##     ##    ##    
	 *    ##     ##    ##    ##   ### ##     ## ##     ##  ##  ##    ##      ## ##    ##  ##       ##  ##  ##    ##     ## ##        ##  ##    ##  ##     ##    ##    
	 *    ########     ##    ##    ## ##     ## ##     ## ####  ######        ###    #### ########  ###  ###     ##     ## ######## ####  ######   ##     ##    ##    
	 */
	function calculateDynamicViewHeight () {
		const html = document.documentElement;
		let lastOrientation = window.matchMedia('(orientation: portrait)').matches ? 'portrait' : 'landscape';

		const setHeroVh = () => {
			const vh = window.innerHeight * 0.01;
			html.style.setProperty('--hero-vh', `${vh}px`);

			if (lenis) {
				refreshLenis();
			}
		}

		// Calcule une seule fois au load
		// setHeroVh();
		html.classList.add('--hero-ready');

		// Recalcule seulement si l’orientation change
		window.addEventListener('resize', () => {
			const currentOrientation = window.matchMedia('(orientation: portrait)').matches ? 'portrait' : 'landscape';

			if (currentOrientation !== lastOrientation) {
				lastOrientation = currentOrientation;
				// setHeroVh();

				if (lenis) {
					refreshLenis();
				}
			}
		});
	}
	calculateDynamicViewHeight();

		/**
	 *    ########  ######## ##     ## ####  ######  ########    #### ##    ## ########  #######   ######  
	 *    ##     ## ##       ##     ##  ##  ##    ## ##           ##  ###   ## ##       ##     ## ##    ## 
	 *    ##     ## ##       ##     ##  ##  ##       ##           ##  ####  ## ##       ##     ## ##       
	 *    ##     ## ######   ##     ##  ##  ##       ######       ##  ## ## ## ######   ##     ##  ######  
	 *    ##     ## ##        ##   ##   ##  ##       ##           ##  ##  #### ##       ##     ##       ## 
	 *    ##     ## ##         ## ##    ##  ##    ## ##           ##  ##   ### ##       ##     ## ##    ## 
	 *    ########  ########    ###    ####  ######  ########    #### ##    ## ##        #######   ######  
	 */
	function deviceInfos() {
		const html = document.documentElement;

		const isPhone = window.matchMedia('(max-width: 767px)').matches;
		const isTablet = window.matchMedia('(min-width: 768px) and (max-width: 1199px)').matches;
		const isMobile = isPhone || isTablet;

		const isTouchDevice = window.matchMedia('(pointer: coarse)').matches;
		const isPointerDevice = window.matchMedia('(pointer: fine)').matches;

		window.isMobile = isMobile;
		window.isTablet = isTablet;
		window.isPhone = isPhone;
		window.isTouchDevice = isTouchDevice;
		window.isPointerDevice = isPointerDevice;

		html.classList.toggle('is-mobile', isMobile);
		html.classList.toggle('is-desktop', !isMobile);
		html.classList.toggle('is-tablet', isTablet);
		html.classList.toggle('is-phone', isPhone);
		html.classList.toggle('is-touch-device', isTouchDevice);
		html.classList.toggle('is-pointer-device', isPointerDevice);

		// html.dataset.viewportWidth = window.innerWidth;
		// html.dataset.viewportHeight = window.innerHeight;
	}

	deviceInfos();

	window.addEventListener('resize', () => {
		deviceInfos();
	});

		/**
	 *    #### ##    ## #### ########    ##     ## ######## ########   #######     ##     ## #### ########  ########  #######   ######  
	 *     ##  ###   ##  ##     ##       ##     ## ##       ##     ## ##     ##    ##     ##  ##  ##     ## ##       ##     ## ##    ## 
	 *     ##  ####  ##  ##     ##       ##     ## ##       ##     ## ##     ##    ##     ##  ##  ##     ## ##       ##     ## ##       
	 *     ##  ## ## ##  ##     ##       ######### ######   ########  ##     ##    ##     ##  ##  ##     ## ######   ##     ##  ######  
	 *     ##  ##  ####  ##     ##       ##     ## ##       ##   ##   ##     ##     ##   ##   ##  ##     ## ##       ##     ##       ## 
	 *     ##  ##   ###  ##     ##       ##     ## ##       ##    ##  ##     ##      ## ##    ##  ##     ## ##       ##     ## ##    ## 
	 *    #### ##    ## ####    ##       ##     ## ######## ##     ##  #######        ###    #### ########  ########  #######   ######  
	 */
	function initHeroVideos() {
		const heroVideos = document.querySelectorAll('[data-hero-video]');

		if (heroVideos.length === 0) return;

		heroVideos.forEach(hero => {
			const video = hero.querySelector('video');
			if (!video) return;

			const pageName = hero.dataset.page;
			const basePath = hero.dataset.basePath || 'images/';
			const isMobile = window.innerWidth < 768;

			const videoSrc = isMobile
				? `${basePath}${pageName}_video_m.mp4`
				: `${basePath}${pageName}_video.mp4`;

			const posterSrc = isMobile
				? `${basePath}${pageName}_video_poster_m.jpg`
				: `${basePath}${pageName}_video_poster.jpg`;

			video.setAttribute('poster', posterSrc);

			const source = document.createElement('source');
			source.src = videoSrc;
			source.type = 'video/mp4';

			video.innerHTML = '';
			video.appendChild(source);
			video.load();

			video.play().catch(() => {
				// Certains navigateurs peuvent bloquer autoplay selon le contexte.
			});
		});
	}

	initHeroVideos();

	/**
	 *    ##       ######## ##    ## ####  ######  
	 *    ##       ##       ###   ##  ##  ##    ## 
	 *    ##       ##       ####  ##  ##  ##       
	 *    ##       ######   ## ## ##  ##   ######  
	 *    ##       ##       ##  ####  ##        ## 
	 *    ##       ##       ##   ###  ##  ##    ## 
	 *    ######## ######## ##    ## ####  ######  
	 */
	// Observes the body document for any height change then dispatch the native resize event for lenis to recalculate the page height
	const resizeObserver = new ResizeObserver(() => {
		window.dispatchEvent(new Event('resize'));
	});
	resizeObserver.observe(document.body);

	function initLenis() {
		lenis = new Lenis({
			// Scroll to anchor links is offset by header height
			// anchors: {
			// 	offset: -document.querySelector('.menu-navbar').offsetHeight
			// },
			autoRaf: true,
		});
	}
	initLenis();

	function refreshLenis() {
		if (lenis) lenis.resize();
	}

	/**
	 *       ###    ##    ##  ######  ##     ##  #######  ########     ##       #### ##    ## ##    ##  ######  
	 *      ## ##   ###   ## ##    ## ##     ## ##     ## ##     ##    ##        ##  ###   ## ##   ##  ##    ## 
	 *     ##   ##  ####  ## ##       ##     ## ##     ## ##     ##    ##        ##  ####  ## ##  ##   ##       
	 *    ##     ## ## ## ## ##       ######### ##     ## ########     ##        ##  ## ## ## #####     ######  
	 *    ######### ##  #### ##       ##     ## ##     ## ##   ##      ##        ##  ##  #### ##  ##         ## 
	 *    ##     ## ##   ### ##    ## ##     ## ##     ## ##    ##     ##        ##  ##   ### ##   ##  ##    ## 
	 *    ##     ## ##    ##  ######  ##     ##  #######  ##     ##    ######## #### ##    ## ##    ##  ######  
	 */
	// Prevent the browser from automatically handling the scroll position
	if ('history' in window && 'scrollRestoration' in window) {
		window.history.scrollRestoration = 'manual';
	}

	/**
	*                                                                       
	*      ####  #      ######   ##   #    #    #    #   ##    ####  #    # 
	*     #    # #      #       #  #  ##   #    #    #  #  #  #      #    # 
	*     #      #      #####  #    # # #  #    ###### #    #  ####  ###### 
	*     #      #      #      ###### #  # #    #    # ######      # #    # 
	*     #    # #      #      #    # #   ##    #    # #    # #    # #    # 
	*      ####  ###### ###### #    # #    #    #    # #    #  ####  #    # 
	*                                                                       
	*/
	function cleanHash(hash) {
		if (!hash || hash === '#') return null;

		// Exemple: #form?item=123 devient #form
		if (hash.includes('?')) {
			hash = hash.slice(0, hash.indexOf('?'));
		}

		return hash;
	}

	/**
	 *                                                               
	 *      ####   ####  #####   ####  #      #         #####  ####  
	 *     #      #    # #    # #    # #      #           #   #    # 
	 *      ####  #      #    # #    # #      #           #   #    # 
	 *          # #      #####  #    # #      #           #   #    # 
	 *     #    # #    # #   #  #    # #      #           #   #    # 
	 *      ####   ####  #    #  ####  ###### ######      #    ####  
	 *                                                               
	 */
	function scrollToHash(hash, updateUrl = false) {
		const selector = cleanHash(hash);
		if (!selector) return false;

		const targetElement = document.querySelector(selector);

		if (!targetElement) {
			console.warn('[Lenis anchor] Aucun élément trouvé pour:', selector);
			return false;
		}

		const offset = -document.querySelector('.module-menu .menu-navbar').offsetHeight - 4 || 0;
		
		if (typeof lenis !== 'undefined' && lenis) {
			lenis.scrollTo(targetElement, {
				offset: offset,
				duration: 1.2,
				immediate: false
			});
		} 
		else {
			const top = targetElement.getBoundingClientRect().top + window.scrollY + offset;

			window.scrollTo({
				top: top,
				behavior: 'smooth'
			});
		}

		if (updateUrl) {
			history.pushState(null, '', selector);
		}

		return true;
	}

	/**
	 *                                                  
	 *     #       ####    ##   #####  
	 *     #      #    #  #  #  #    # 
	 *     #      #    # #    # #    # 
	 *     #      #    # ###### #    # 
	 *     #      #    # #    # #    # 
	 *     ######  ####  #    # #####  
	 *                                                  
	 */
	// Gestion au chargement d'une page avec un hash
	window.addEventListener('load', () => {
		if (!window.location.hash) return;

		const hash = window.location.hash;

		// Important avec Lenis : on remet la page en haut avant le scroll smooth
		if (typeof lenis !== 'undefined' && lenis) {
			lenis.scrollTo(0, {
				immediate: true
			});
		} 
		else {
			window.scrollTo(0, 0);
		}

		// Petit délai pour laisser Lenis, les images et le layout se placer
		setTimeout(() => {
			scrollToHash(hash, false);
		}, 100);
	});

	/**
	 *                                                    
	 *      ####  #      #  ####  #    # 
	 *     #    # #      # #    # #   #  
	 *     #      #      # #      ####   
	 *     #      #      # #      #  #   
	 *     #    # #      # #    # #   #  
	 *      ####  ###### #  ####  #    # 
	 *                                                    
	 */
	// Gestion des clics sur les liens avec #
	document.addEventListener('click', (e) => {
		
		const headerOrFooterLogoEvent = e.target.classList.contains('header-logo') || e.target.classList.contains('footer-logo');
		const isHome = document.querySelector('body').classList.contains('index');
		const targetLink = e.target.closest('a[href*="#"]');
		
		if (headerOrFooterLogoEvent && isHome) {
			e.preventDefault();

			if (typeof lenis !== 'undefined' && lenis) {
				lenis.scrollTo(0, {
					duration: 1.2,
					immediate: false
				});
			} 
			else {
				window.scrollTo({
					top: 0,
					behavior: "smooth",
				});
			}
		}

		if (!targetLink) return;

		const href = targetLink.getAttribute('href');
		
		if (!href || href === '#') return;

		const urlObject = new URL(href, window.location.href);

		if (!urlObject.hash) return;

		const isSamePage =
			urlObject.origin === window.location.origin &&
			urlObject.pathname === window.location.pathname &&
			urlObject.search === window.location.search;

		// Si le lien mène à une autre page, on laisse le navigateur changer de page.
		// Le window.load de la page suivante s'occupera du scroll smooth.
		if (!isSamePage) return;

		// Même page, on bloque le saut natif
		e.preventDefault();

		scrollToHash(urlObject.hash, true);
	});

	/**
	 *    ########     ###     ######   ########    ######## ########     ###    ##    ##  ######  #### ######## ####  #######  ##    ##  ######  
	 *    ##     ##   ## ##   ##    ##  ##             ##    ##     ##   ## ##   ###   ## ##    ##  ##     ##     ##  ##     ## ###   ## ##    ## 
	 *    ##     ##  ##   ##  ##        ##             ##    ##     ##  ##   ##  ####  ## ##        ##     ##     ##  ##     ## ####  ## ##       
	 *    ########  ##     ## ##   #### ######         ##    ########  ##     ## ## ## ##  ######   ##     ##     ##  ##     ## ## ## ##  ######  
	 *    ##        ######### ##    ##  ##             ##    ##   ##   ######### ##  ####       ##  ##     ##     ##  ##     ## ##  ####       ## 
	 *    ##        ##     ## ##    ##  ##             ##    ##    ##  ##     ## ##   ### ##    ##  ##     ##     ##  ##     ## ##   ### ##    ## 
	 *    ##        ##     ##  ######   ########       ##    ##     ## ##     ## ##    ##  ######  ####    ##    ####  #######  ##    ##  ######  
	 */
	const pageTransitionDuration = 800;

	function initPageTransitions() {
		const html = document.querySelector('html');

		if (!html) return;

		function resetPageState() {
			html.classList.remove('--page-leaving');

			requestAnimationFrame(() => {
				html.classList.add('--page-loaded');
			});
		}

		function startPageLeaving(url) {
			html.classList.remove('--page-loaded');
			html.classList.add('--page-leaving');

			setTimeout(() => {
				window.location.href = url.href;
			}, pageTransitionDuration);
		}

		resetPageState();

		window.addEventListener('pageshow', function() {
			resetPageState();
			// if (event.persisted) {
			// 	console.log('The page was restored from the bfcache.');
			// } else {
			// 	console.log('The page was loaded normally.');
			// }
		});

		document.addEventListener('click', function(event) {
			if (!(event.target instanceof Element)) return;

			const link = event.target.closest('a');

			if (!link) return;

			if (link.classList.contains('gallery-item')) return;

			const href = link.getAttribute('href');

			if (
				!href ||
				href.startsWith('#') ||
				href.startsWith('javascript:') ||
				href.startsWith('mailto:') ||
				href.startsWith('tel:') ||
				link.target === '_blank' ||
				link.hasAttribute('download') ||
				event.metaKey ||
				event.ctrlKey ||
				event.shiftKey ||
				event.altKey
			) {
				return;
			}

			const url = new URL(link.href, window.location.origin);

			if (url.origin !== window.location.origin) return;

			// Même page exacte
			if (url.href === window.location.href) return;

			// Même page, mais seulement une ancre différente
			if (
				url.pathname === window.location.pathname &&
				url.search === window.location.search &&
				url.hash
			) {
				return;
			}

			event.preventDefault();

			startPageLeaving(url);
		});
	}

	initPageTransitions();

	
	/**
	 *     ######   #######   #######  ##    ## #### ######## 
	 *    ##    ## ##     ## ##     ## ##   ##   ##  ##       
	 *    ##       ##     ## ##     ## ##  ##    ##  ##       
	 *    ##       ##     ## ##     ## #####     ##  ######   
	 *    ##       ##     ## ##     ## ##  ##    ##  ##       
	 *    ##    ## ##     ## ##     ## ##   ##   ##  ##       
	 *     ######   #######   #######  ##    ## #### ######## 
	 */
	function setCookie(name, value, hours) {
		const maxAge = hours * 60 * 60;

		document.cookie = `${name}=${value}; max-age=${maxAge}; path=/; SameSite=Lax`;
	}

	function getCookie(name) {
		return document.cookie
			.split('; ')
			.find(row => row.startsWith(`${name}=`))
			?.split('=')[1];
	}

	/**
	 *    ##     ##  #######  ##     ## ########    #### ##    ## ######## ########   #######  
	 *    ##     ## ##     ## ###   ### ##           ##  ###   ##    ##    ##     ## ##     ## 
	 *    ##     ## ##     ## #### #### ##           ##  ####  ##    ##    ##     ## ##     ## 
	 *    ######### ##     ## ## ### ## ######       ##  ## ## ##    ##    ########  ##     ## 
	 *    ##     ## ##     ## ##     ## ##           ##  ##  ####    ##    ##   ##   ##     ## 
	 *    ##     ## ##     ## ##     ## ##           ##  ##   ###    ##    ##    ##  ##     ## 
	 *    ##     ##  #######  ##     ## ########    #### ##    ##    ##    ##     ##  #######  
	 */
	function delay(ms) {
		return new Promise(resolve => setTimeout(resolve, ms));
	}

	function staggerElements(elements, className = '--active', delayStart = 0, stagger = 60) {
		elements.forEach((element, index) => {
			setTimeout(() => {
				element.classList.add(className);
			}, delayStart + index * stagger);
		});
	}

	async function homeIntroAnimation() {
		const body = document.body;

		// Bail if not on the homepage
		if (!body.classList.contains('index')) return;

		// Shuffle function
		// const shuffle = (array) => {
		// 	array.sort(() => Math.random() - 0.5);
		// };
		
		const html = document.documentElement;
		const header = document.querySelector('.module-menu .menu-navbar');
		const heroElements = document.querySelectorAll('.slideshow-wrap__wrapper [data-element]');
		const overlay = document.querySelector('.home-intro-overlay');

		if (!overlay) {
			html.classList.add('--skip-home-intro');
			staggerElements(heroElements, '--active', 300, 60);
			
			return;
		} 
		
		const isMobile = window.innerWidth < 768;
		const gridElements = [];
		const gridElementsNumber = isMobile ? 9 : 12;

		for (let i = 0; i < gridElementsNumber; i++) {

			const element = document.createElement('div');
			element.classList.add('grid-content');

			gridElements.push(element);
			overlay.querySelector('.home-intro-overlay__content').appendChild(element);
		}

		gridElements.reverse();

		// Randomize the grid animation
		// shuffle(gridElements);

		// Get homeIntro cookie
		// For debug in console: document.cookie = 'homeIntroPlayed=; max-age=0; path=/; SameSite=Lax';
		const homeIntroPlayed = getCookie('homeIntroPlayed');

		// Bail if home intro has already been played
		if (!homeIntroPlayed) {
			const heroMedia = body.querySelector('.slideshow-wrap__wrapper.video video');
			heroMedia.pause();
			lenis?.stop();

			html.classList.add('--first-home-load');
			html.style.overflow = 'hidden';

			// 0.5s
			await delay(500);
			staggerElements(gridElements, '--active', 300, 20);
			heroMedia.play();

			// 1.8s
			await delay(1300);
			html.classList.add('--logo-invisible');
			staggerElements(heroElements, '--active', 300, 60);

			// 2.3s
			await delay(500);
			html.classList.add('--intro-header-visible');

			// 3s
			await delay(900);
			html.classList.add('--first-home-load-completed');
			html.style.overflow = '';
			overlay.remove();
			lenis?.start();

			// Saves the intro being played into the user's cookies for 48 hours, or any other length
			setCookie('homeIntroPlayed', 'true', 48);
		} 
		// Else animation hero elements from bottom
		else {
			$(overlay).remove();
			html.classList.add('--skip-home-intro');
			staggerElements(heroElements, '--active', 300, 60);
		}
	}

	homeIntroAnimation();

	/**
	 *    ##     ##    ###     ######  ##    ##    #### ##    ## ########  ##     ## ######## 
	 *    ###   ###   ## ##   ##    ## ##   ##      ##  ###   ## ##     ## ##     ##    ##    
	 *    #### ####  ##   ##  ##       ##  ##       ##  ####  ## ##     ## ##     ##    ##    
	 *    ## ### ## ##     ##  ######  #####        ##  ## ## ## ########  ##     ##    ##    
	 *    ##     ## #########       ## ##  ##       ##  ##  #### ##        ##     ##    ##    
	 *    ##     ## ##     ## ##    ## ##   ##      ##  ##   ### ##        ##     ##    ##    
	 *    ##     ## ##     ##  ######  ##    ##    #### ##    ## ##         #######     ##    
	 */
    if ($.fn.mask) {
        $("input[type='tel']").mask("(999) 999-9999? #99999");
        $("input[type='text'].postalcode").mask("a9a 9a9", {
            completed:function () {
                this.val(this.val().toUpperCase());
            }
        });
    }

	/**
	 *   ##     ##    ###    ########  ######  ##     ## ######## ####  ######   ##     ## ######## 
	 *   ###   ###   ## ##      ##    ##    ## ##     ## ##        ##  ##    ##  ##     ##    ##    
	 *   #### ####  ##   ##     ##    ##       ##     ## ##        ##  ##        ##     ##    ##    
	 *   ## ### ## ##     ##    ##    ##       ######### ######    ##  ##   #### #########    ##    
	 *   ##     ## #########    ##    ##       ##     ## ##        ##  ##    ##  ##     ##    ##    
	 *   ##     ## ##     ##    ##    ##    ## ##     ## ##        ##  ##    ##  ##     ##    ##    
	 *   ##     ## ##     ##    ##     ######  ##     ## ######## ####  ######   ##     ##    ##    
	 */
	if ($.fn.matchHeight) {
		$(".matchHeight").matchHeight();
	}

	/**
	 *     #######  ########   ######  ######## ########  ##     ## ######## ########  
	 *    ##     ## ##     ## ##    ## ##       ##     ## ##     ## ##       ##     ## 
	 *    ##     ## ##     ## ##       ##       ##     ## ##     ## ##       ##     ## 
	 *    ##     ## ########   ######  ######   ########  ##     ## ######   ########  
	 *    ##     ## ##     ##       ## ##       ##   ##    ##   ##  ##       ##   ##   
	 *    ##     ## ##     ## ##    ## ##       ##    ##    ## ##   ##       ##    ##  
	 *     #######  ########   ######  ######## ##     ##    ###    ######## ##     ## 
	 */
	function scrollAnimation(element, options = {rootMargin: '0px 0px 0px 0px'}) {
		const observer = new IntersectionObserver(watch, options);
	
		const items = element.querySelectorAll('[data-scroll]');
		items.forEach(item => observer.observe(item));
		
		function watch(entries, observer) {
			entries.forEach(entry => {
				const target = entry.target;
				
				if (entry.isIntersecting) {
					target.classList.add('is-active');
					observer.unobserve(target);
					
				} else {
					target.classList.remove('is-active');
				}
			});
		}
	}

	// put .scroll-animation-container on the body of every page that needs to be observed for animations on scroll
	const elements = document.querySelectorAll('.scroll-animation-container');
	elements.forEach(element => scrollAnimation(element));


	/**
	 *    ##     ## ######## ##    ## ##     ##    ########  #######   ######    ######   ##       ######## 
	 *    ###   ### ##       ###   ## ##     ##       ##    ##     ## ##    ##  ##    ##  ##       ##       
	 *    #### #### ##       ####  ## ##     ##       ##    ##     ## ##        ##        ##       ##       
	 *    ## ### ## ######   ## ## ## ##     ##       ##    ##     ## ##   #### ##   #### ##       ######   
	 *    ##     ## ##       ##  #### ##     ##       ##    ##     ## ##    ##  ##    ##  ##       ##       
	 *    ##     ## ##       ##   ### ##     ##       ##    ##     ## ##    ##  ##    ##  ##       ##       
	 *    ##     ## ######## ##    ##  #######        ##     #######   ######    ######   ######## ######## 
	 */
	const menu = ".menu-mobile";
	const menuToggle = ".menu-toggle, .menu-close";

	$(menuToggle).click(function(e) {
		$(menu).toggleClass("toggled");
		$(menuToggle).toggleClass("toggled");

		// If menu is open, disable scroll on page
		if (document.querySelector(menu).classList.contains("toggled")) {
			lenis.stop();
		}
		// Else, reactivate lenis scroll
		else {
			lenis.start();
		}
	});

	// Open dropdowns on click
	const mobileDropdowns = document.querySelectorAll('.menu-mobile .dropdown');
	mobileDropdowns.forEach(dropdown => {
		const dropdownToggleLink = dropdown.querySelector('.dropdown-link');
		if (dropdownToggleLink) {
			dropdownToggleLink.href = "javascript:void(0)";
		}

		// If any subitem is active, opens the dropdown
		if (dropdown.classList.contains('active')) {
			dropdown.classList.add('--is-open');
			if (lenis) refreshLenis();
		}
		
		// Open the dropdown
		dropdown.querySelector('a:first-child').addEventListener('click', (e) => {

			const dropdownLink = $(this).find('a.dropdown-link');
			if (dropdownLink) dropdownLink.href = "javascript:void(0)";

			dropdown.classList.toggle('--is-open');

			// Si les items du sous-menu sont des ancres dans la même page, on ferme le menu puis
			// on start lenis pour scroll jusqu'à la bonne section
			const subitemLink = $(e.target).closest('a').get(0);
			if (subitemLink.hash) {
				$(menu).removeClass("toggled");
				$(menuToggle).removeClass("toggled");
				lenis.start();
			}
			if (lenis) refreshLenis();
		})
	});


	/**
	 *    ##     ## ######## ##    ## ##     ##    ##     ## #### ########  ######## 
	 *    ###   ### ##       ###   ## ##     ##    ##     ##  ##  ##     ## ##       
	 *    #### #### ##       ####  ## ##     ##    ##     ##  ##  ##     ## ##       
	 *    ## ### ## ######   ## ## ## ##     ##    #########  ##  ##     ## ######   
	 *    ##     ## ##       ##  #### ##     ##    ##     ##  ##  ##     ## ##       
	 *    ##     ## ##       ##   ### ##     ##    ##     ##  ##  ##     ## ##       
	 *    ##     ## ######## ##    ##  #######     ##     ## #### ########  ######## 
	 */
    let didScroll;
    let lastScrollTop = 0;
    const delta = 10;
    let navbarHeight = $(".menu-navbar").outerHeight();

    // Function to store scroll amount in <html data-scroll="">
	const storeScroll = () => {
        document.documentElement.dataset.scroll = window.scrollY;
    }

    // Set flag to see if window has scrolled
	$(window).scroll( function(event) {
		didScroll = true;
        storeScroll();
	});

    // Calls all scroll dependent scripts
    // And cut on processing time by the browser
    // by reading stats only x milliseconds (250)
	setInterval(function() {
		if (didScroll) {
            menuHasScrolled();
            toggleVisibleClassOnScroll();
            didScroll = false;
		}
	}, 0);

	// if element has "visibilityCheck" it will have "isVisible" class when
    // visible
	function toggleVisibleClassOnScroll() {
        $('.visibilityCheck').is( function () {
            let viewing = $(this).visible(true);
            if (viewing) {
                $(this).addClass('isVisible');
            } else {
                $(this).removeClass('isVisible');
            }
        });
        $('.completeVisibilityCheck').is( function () {
            let viewing = $(this).visible();
            if (viewing) {
                $(this).addClass('isCompletelyVisible');
            } else {
                $(this).removeClass('isCompletelyVisible');
            }
        });
    }

    // Adds the nav-invisible and nav-visible to element with class menu-desktop
	function menuHasScrolled() {
        let st = parseInt(document.documentElement.dataset.scroll);

        // Make sure they scroll more than delta
	    if ( Math.abs(lastScrollTop - st) <= delta )
	        return;
	    // If they scrolled down and are past the navbar, add class .nav-invisible.
	    // This is necessary so you never see what is "behind" the navbar.
        //console.log('st: ' + st);
        //console.log('lastScrollTop: ' + lastScrollTop);

        if ( st < parseInt(lastScrollTop) ) {
            // Scroll Up
            $('.menu-navbar').addClass('nav-visible').removeClass('nav-invisible');
        }
	    if (st > lastScrollTop && st > navbarHeight) {
	        // Scroll Down
	        $('.menu-navbar').removeClass('nav-visible').addClass('nav-invisible');
	    }

		lastScrollTop = st;
		
		if (st >= 0 && st <= 20) {
			$('.module-menu').removeClass('scrolled');
		}
		else {
			$('.module-menu').addClass('scrolled');
		}
	}

	
    $(document).ready(function () {
        storeScroll();
		toggleVisibleClassOnScroll();
		//code pour cacher les title SEO dans les images
		$("img[title]").hover(function(){
			$(this).attr("rel", $(this).attr("title"));
			$(this).removeAttr("title");
		}, function(){
			$(this).attr("title", $(this).attr("rel"));
			$(this).removeAttr("rel");
		});
    });

	/**
	 *       ###     ######   ######   #######  ########  ########  ####  #######  ##    ##  ######  
	 *      ## ##   ##    ## ##    ## ##     ## ##     ## ##     ##  ##  ##     ## ###   ## ##    ## 
	 *     ##   ##  ##       ##       ##     ## ##     ## ##     ##  ##  ##     ## ####  ## ##       
	 *    ##     ## ##       ##       ##     ## ########  ##     ##  ##  ##     ## ## ## ##  ######  
	 *    ######### ##       ##       ##     ## ##   ##   ##     ##  ##  ##     ## ##  ####       ## 
	 *    ##     ## ##    ## ##    ## ##     ## ##    ##  ##     ##  ##  ##     ## ##   ### ##    ## 
	 *    ##     ##  ######   ######   #######  ##     ## ########  ####  #######  ##    ##  ######  
	 */
	const accordions = document.querySelectorAll('.accordion');
	
	if (accordions?.length) {

		const openAccordion = (accordion) => {
			const content = accordion.querySelector('.content-wrapper');

			if (!content) return;

			accordion.classList.add('--is-open');
			content.style.maxHeight = `${content.scrollHeight}px`;
			content.setAttribute('aria-hidden', 'false');
		};

		const closeAccordion = (accordion) => {
			const content = accordion.querySelector('.content-wrapper');

			if (!content) return;

			accordion.classList.remove('--is-open');
			content.style.maxHeight = null;
			content.setAttribute('aria-hidden', 'true');
		};

		accordions.forEach((accordion) => {
			const content = accordion.querySelector('.content-wrapper');
			const accordionToggle = accordion.querySelector('summary');

			if (!content) return;

			content.setAttribute(
				'aria-hidden',
				accordion.classList.contains('--is-open') ? 'false' : 'true'
			);

			accordionToggle.addEventListener('click', (event) => {

				if (event.target.closest('.content-wrapper')) return;

					const shouldOpen = !accordion.classList.contains('--is-open');

					// Ferme tous les accordéons.
					accordions.forEach(closeAccordion);

					// Ouvre celui qui a été cliqué seulement s'il était fermé.
					if (shouldOpen) {
						openAccordion(accordion);
					}
				});
		});

		let resizeFrame;

		window.addEventListener('resize', () => {
			cancelAnimationFrame(resizeFrame);

			resizeFrame = requestAnimationFrame(() => {
				accordions.forEach((accordion) => {
					if (accordion.classList.contains('--is-open')) {
						const content = accordion.querySelector('.content-wrapper');

						if (content) {
							content.style.maxHeight = `${content.scrollHeight}px`;
						}
					}
				});
			});
		});
	}

	/**
	 *    ########  #######  ########  ##     ##    ##     ##    ###    ##       #### ########     ###    ######## ####  #######  ##    ##  ######  
	 *    ##       ##     ## ##     ## ###   ###    ##     ##   ## ##   ##        ##  ##     ##   ## ##      ##     ##  ##     ## ###   ## ##    ## 
	 *    ##       ##     ## ##     ## #### ####    ##     ##  ##   ##  ##        ##  ##     ##  ##   ##     ##     ##  ##     ## ####  ## ##       
	 *    ######   ##     ## ########  ## ### ##    ##     ## ##     ## ##        ##  ##     ## ##     ##    ##     ##  ##     ## ## ## ##  ######  
	 *    ##       ##     ## ##   ##   ##     ##     ##   ##  ######### ##        ##  ##     ## #########    ##     ##  ##     ## ##  ####       ## 
	 *    ##       ##     ## ##    ##  ##     ##      ## ##   ##     ## ##        ##  ##     ## ##     ##    ##     ##  ##     ## ##   ### ##    ## 
	 *    ##        #######  ##     ## ##     ##       ###    ##     ## ######## #### ########  ##     ##    ##    ####  #######  ##    ##  ######  
	 */
	const forms = document.querySelectorAll('form');

	/**
	 *                                                                                                                 
	 *     ####  #####   ####  #    # #####  
	 *    #    # #    # #    # #    # #    # 
	 *    #      #    # #    # #    # #    # 
	 *    #  ### #####  #    # #    # #####  
	 *    #    # #   #  #    # #    # #      
	 *     ####  #    #  ####   ####  #      
	 *                                                                                                                 
	 */
	// Fonction de vérification d'un groupe de radios/checkboxes où au moins une des options est obligatoire
	// Doit avoir un input caché à la fin du groupe .custom-input-group
	// <input 
	// 	type="text" 
	// 	name="demande_required" 
	// 	class="input-hidden-validator" 
	// 	required 
	// 	style="position:absolute; opacity:0; pointer-events:none;"
	// >
	function validateCustomInputGroup(group, showError = true) {
		const inputs = group.querySelectorAll(
			'input[type="checkbox"], input[type="radio"]'
		);

		const hiddenInput = group.querySelector('.input-hidden-validator');
		const errorBlock = group.querySelector('.custom-error-block');

		if (!inputs.length || !hiddenInput) return true;

		const checked = [...inputs].some(input => input.checked);

		if (checked) {
			hiddenInput.value = 'ok';

			group.classList.remove('has-error');

			if (errorBlock) {
				errorBlock.innerHTML = '';
			}

			return true;
		}

		hiddenInput.value = '';

		if (showError) {
			group.classList.add('has-error');

			if (errorBlock) {
				errorBlock.innerHTML = `
					<ul>
						<li>${hiddenInput.validationMessage}</li>
					</ul>
				`;
			}
		}

		return false;
	}

	// Pour chaque formulaire, on valide les groupes de radios/checkboxes
	// où au moins une option doit être sélectionnée
	if (forms.length) {
		forms.forEach(form => {
			const groups = form.querySelectorAll('.custom-input-group');

			if (!groups.length) return;

			// Lorsqu'on change une checkbox/radio:
			// on valide seulement son groupe
			form.addEventListener('change', e => {
				if (!e.target.matches('input[type="checkbox"], input[type="radio"]')) {
					return;
				}

				const group = e.target.closest('.custom-input-group');

				if (group) {
					validateCustomInputGroup(group);
				}
			});

			// Au submit
			// on valide tous les groupes
			form.addEventListener('submit', e => {
				let isValid = true;

				groups.forEach(group => {
					if (!validateCustomInputGroup(group)) {
						isValid = false;
					}
				});

				if (!isValid) {
					e.preventDefault();
				}
			});
		});
	}

	/**
	 *                                                                                
	 *     ###### # #      ######  ####     #    # #####  #       ####    ##   #####  
	 *     #      # #      #      #         #    # #    # #      #    #  #  #  #    # 
	 *     #####  # #      #####   ####     #    # #    # #      #    # #    # #    # 
	 *     #      # #      #           #    #    # #####  #      #    # ###### #    # 
	 *     #      # #      #      #    #    #    # #      #      #    # #    # #    # 
	 *     #      # ###### ######  ####      ####  #      ######  ####  #    # #####  
	 *                                                                                
	 */
	function handleFiledocValidation(selectedFiles = [], inputFiledoc) {

		// File infos elements
		const fileBtn = inputFiledoc;
		const filePreview = document.getElementById('fp');
		const totalSizeBlock = document.getElementById('divTotalSize');
		const filesInfosContainer = document.querySelector('.files-infos');
		
		// Messages for alert or files infos		
		let message = {};
		if (!isEn) {
			message = {
				file : 'Fichier',
				total: 'Taille totale des fichiers',
				errorTitle: 'Erreur',
				errorFile: 'Fichier refusé',
				totalExceeded: 'La taille totale des fichiers dépasse la limite permise de'
			}
		}
		else {
			message = {
				file : 'File',
				total: 'Total files size',
				errorTitle: 'Error',
				errorFile: 'File refused',
				totalExceeded: 'The total file size exceeds the allowed limit of'
			}
		}
		
		// Tableau des nouveaux fichiers
		const newFiles = Array.from(fileBtn.files);
		const dt = new DataTransfer();
		
		// Total du poids des fichiers et poids maximal
		const maxTotalSize = parseInt(fileBtn.dataset.maxTotalSize, 10);
		let total = selectedFiles.reduce((sum, file) => sum + file.size, 0);
		let rejectedFiles = [];

		// Form alert
		const formAlert = document.querySelector('#section-form-alert');
		const formMessage = formAlert.querySelector('.form-alert__message');

		// Pour chaque nouveau fichier, on vérifie que le poids total des fichiers
		// et celui du nouveau n'excède pas la limite du serveur
		newFiles.forEach(file => {
			// Si la limite n'est pas excédée, on affiche le fichier et le poids total
			if (total + file.size <= maxTotalSize) {
				selectedFiles.push(file);
				total += file.size;
			} 
			// Sinon, on stocke le ou les fichiers qui excèdent le poids dans un tableau pour les afficher dans le message d'erreur
			else {
				rejectedFiles.push(file.name);
			}
		});

		// Pour chaque fichier sélectionné, on le stocke dans l'objet DataTransfer
		selectedFiles.forEach(file => {
			dt.items.add(file);
		});
		fileBtn.files = dt.files;

		// On réinitialise les états des messages et des conteneurs
		filePreview.innerHTML = '';
		totalSizeBlock.innerHTML = '';
		filesInfosContainer.classList.remove('active');

		// On affiche l'info de chaque fichier
		selectedFiles.forEach((file, i) => {
			filePreview.innerHTML += `
				<div class="file-info">
					<label class="preview-file">${message.file} ${i + 1}:</label>
					<p>${file.name}</p>
				</div>
			`;
		});

		// S'il y a des fichiers valides, on affiche le conteneur d'informations des fichiers pour la taille total et le nom de ceux-ci
		if (selectedFiles.length > 0) {
			filesInfosContainer.classList.add('active');
			totalSizeBlock.innerHTML =
				`${message.total} : <b>${Math.round(total / 1024)} KB</b>`;
		}

		// S'il y a des fichiers qui excèdent la limite, on les affiche dans le message d'erreur
		if (rejectedFiles.length > 0) {
			formAlert.classList.add('--is-active');
			formAlert.querySelector('.form-alert__container').classList.add('error');
			
			// On affiche les fichiers trop lourds
			formMessage.innerHTML = `
				<h4>${message.errorTitle}</h4>
				<p>${message.totalExceeded} <b>${Math.round(maxTotalSize / 1024 / 1024)} Mo</b>.</p>
				<p>${message.errorFile} : ${rejectedFiles.join(', ')}</p>
			`;

			// Après 4 secondes, on fait disparaître le message d'erreur
			setTimeout(() => {
				formAlert.classList.remove('--is-active');
				formAlert.querySelector('.form-alert__container').classList.remove('error');
				formMessage.innerHTML = '';
			}, 4000);

			return;
		}
	}
	if (forms.length !== 0) {
		forms.forEach(form => {
			let selectedFiles = [];
			const inputFiledoc = form.querySelector('input[type="file"]');
			
			if (!inputFiledoc) {
				return;
			}
		
			inputFiledoc.addEventListener('change', () => {
				handleFiledocValidation(selectedFiles, inputFiledoc)
			});
		});
	}


	/**
	 *    ##     ## ########  ######   ######     ###     ######   ########  ######  
	 *    ###   ### ##       ##    ## ##    ##   ## ##   ##    ##  ##       ##    ## 
	 *    #### #### ##       ##       ##        ##   ##  ##        ##       ##       
	 *    ## ### ## ######    ######   ######  ##     ## ##   #### ######    ######  
	 *    ##     ## ##             ##       ## ######### ##    ##  ##             ## 
	 *    ##     ## ##       ##    ## ##    ## ##     ## ##    ##  ##       ##    ## 
	 *    ##     ## ########  ######   ######  ##     ##  ######   ########  ######  
	 */
	$(document).ready(function () {
        if($('.errors').length) {
            $('html, body').animate({
                scrollTop: $('.errors').offset().top + 200
            }, 'slow');
        }
    });

    $(document).ready(function () {
		if($('.messages').length) {
			$('html, body').animate({
				scrollTop: $('.messages').offset().top + 200
			}, 'slow');
		}
    });

    $('.caption').addClass ('show');
});
